<template>
    <div style="width:100%; border: 1px gray solid; min-height:450px">
        <div style="width:90%; background:#5DC0FF; height:25px; padding:5%; color:white">
            <el-row :gutter="20">
                <el-col :span="6"><font color="#5DC0FF">占位</font></el-col>
                <el-col :span="12"><center>{{title}}</center></el-col>
                <el-col :span="6"><div style="float:right;"><i class="el-icon-plus" @click="add"></i></div></el-col>
            </el-row>
        </div>
        <table style="width:100%; padding:15px;">
            <tr v-for="item in list" :key="item" style="height:40px;">
                <td width="5%"></td>
                <td width="80%">{{item.name}}</td>
                <td><i @click="del(item.id)" class="el-icon-delete" style="float:right;"></i></td>
            </tr>
        </table>
    </div>
</template>
<script>
export default {
    props:['title'],
    data(){
        return{
            list:[],
        }
    },
    mounted(){
        this.loadData();
    },
    methods:{
        loadData(){
            if(this.title == '泊位'){
                this.$api.ningboApi.findAllDicBerth(response => {
                    this.list.length = 0
                    for(var i=0; i<response.length; i++){
                        if(response[i].state == 1){
                            this.list.push(response[i]);
                        }
                    }
                });
            }else if(this.title == '堆场'){
                this.$api.ningboApi.findAllDicArea(response => {
                    this.list.length = 0
                    for(var i=0; i<response.length; i++){
                        if(response[i].state == 1){
                            this.list.push(response[i]);
                        }
                    }
                });
            }else if(this.title == '类型'){
                this.$api.ningboApi.findAllDicType(response => {
                    this.list.length = 0
                    for(var i=0; i<response.length; i++){
                        if(response[i].state == 1){
                            this.list.push(response[i]);
                        }
                    }
                });
            }else if(this.title == '码头设备'){
                this.$api.ningboApi.findAllDicDockDev(response => {
                    this.list.length = 0
                    for(var i=0; i<response.length; i++){
                        if(response[i].state == 1){
                            this.list.push(response[i]);
                        }
                    }
                });
            }
        },
        add(){
            this.$prompt('请输入' + this.title, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                
                }).then(({ value }) => {
                    if(this.title == '泊位'){
                        this.$api.ningboApi.newDicBerth(value, response => {
                            this.loadData();
                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            });
                        }, failure => {
                            this.$message({
                                type: 'error',
                                message: failure
                            });
                        });
                    }else if(this.title == '堆场'){
                        this.$api.ningboApi.newDicArea(value, response => {
                            this.loadData();
                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            });
                        }, failure => {
                            this.$message({
                                type: 'error',
                                message: failure
                            });
                        });
                    }else if(this.title == '类型'){
                        this.$api.ningboApi.newDicType(value, response => {
                            this.loadData();
                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            });
                        }, failure => {
                            this.$message({
                                type: 'error',
                                message: failure
                            });
                        });
                    }else if(this.title == '码头设备'){
                        this.$api.ningboApi.newDicDockDev(value, response => {
                            this.loadData();
                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            });
                        }, failure => {
                            this.$message({
                                type: 'error',
                                message: failure
                            });
                        });
                    }
                });
        },
        del(id){
            this.$confirm('确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.delImpl(id);
            })
        },
        delImpl(id){
            if(this.title == '泊位'){
                this.$api.ningboApi.delDicBerth(id, response => {
                    this.loadData();
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    });
                }, failure => {
                    this.$message({
                        type: 'error',
                        message: failure
                    });
                });
            }else if(this.title == '堆场'){
                this.$api.ningboApi.delDicArea(id, response => {
                    this.loadData();
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    });
                }, failure => {
                    this.$message({
                        type: 'error',
                        message: failure
                    });
                });
            }else if(this.title == '类型'){
                this.$api.ningboApi.delDicType(id, response => {
                    this.loadData();
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    });
                }, failure => {
                    this.$message({
                        type: 'error',
                        message: failure
                    });
                });
            }else if(this.title == '码头设备'){
                this.$api.ningboApi.delDicDockDev(id, response => {
                    this.loadData();
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    });
                }, failure => {
                    this.$message({
                        type: 'error',
                        message: failure
                    });
                });
            }
        }
    }
}
</script>